import {Action, createReducer, on} from '@ngrx/store'
import {initialPaymentState, PaymentState} from '../state/payment.state'
import {CLEAR_EXPENSE_PAYMENTS_HISTORY, FETCH_EXPENSE_PAYMENTS_HISTORY_SUCCESS} from '../action/payment.action'

export function paymentReducer(state: PaymentState, action: Action) {
  return _paymentReducer(state, action)
}

const _paymentReducer = createReducer(
  initialPaymentState,
  on(FETCH_EXPENSE_PAYMENTS_HISTORY_SUCCESS, (state, { expensePaymentHistory }) => {
    return {
      ...state,
      expensePaymentHistory
    }
  }),
  on(CLEAR_EXPENSE_PAYMENTS_HISTORY, (state, {}) => {
    return {
      ...state,
      expensePaymentHistory: null
    }
  })
)
